"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButtonGroup = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiTheme = require("@kyruus/ui-theme");
var _RadioButton = require("./RadioButton");
var _CustomRadioButton = require("./CustomRadioButton");
const StyledFieldset = /*#__PURE__*/(0, _base.default)('fieldset', process.env.NODE_ENV === "production" ? {
  target: "e1hem7h21"
} : {
  target: "e1hem7h21",
  label: "StyledFieldset"
})("border:none;padding:", (0, _uiTheme.fromTheme)('spacing_medium'), " 0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const rowStyles = props => `
  display: flex;
  justify-content: space-between;
  gap: ${(0, _uiTheme.fromTheme)('spacing_medium')(props)};
  text-align: center;
  > div {
    display: flex;
    flex-grow: 1;
  }
`;
const columnStyles = props => `
  display: flex;
  flex-direction: column;
  gap: ${(0, _uiTheme.fromTheme)('spacing_medium')(props)};
`;
const StyleRadioContainer = /*#__PURE__*/(0, _base.default)('div', process.env.NODE_ENV === "production" ? {
  target: "e1hem7h20"
} : {
  target: "e1hem7h20",
  label: "StyleRadioContainer"
})(props => props.row ? rowStyles : columnStyles, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
const RadioButtonGroup = _ref => {
  let {
    ariaDescribedby,
    legend,
    name,
    options,
    value,
    buttonStyle,
    row,
    onChange,
    RenderOption,
    RenderSelectedOption,
    className,
    focusTextColor,
    focusBackgroundColor,
    focusOutlineColor,
    focusOutlineWidth,
    focusOutlineStyle,
    focusOutlineOffset
  } = _ref;
  let radios;
  if (RenderOption && RenderSelectedOption) {
    radios = (0, _map.default)(options).call(options, (option, index) => /*#__PURE__*/_react.default.createElement(_CustomRadioButton.CustomRadioButton, {
      key: index,
      name: name,
      option: option,
      checked: option.value === value,
      onChange: onChange,
      RenderOption: RenderOption,
      RenderSelectedOption: RenderSelectedOption,
      disabled: option.disabled,
      focusTextColor: focusTextColor,
      focusBackgroundColor: focusBackgroundColor,
      focusOutlineColor: focusOutlineColor,
      focusOutlineWidth: focusOutlineWidth,
      focusOutlineStyle: focusOutlineStyle,
      focusOutlineOffset: focusOutlineOffset
    }));
  } else {
    radios = (0, _map.default)(options).call(options, (option, index) => /*#__PURE__*/_react.default.createElement(_RadioButton.RadioButton, {
      key: index,
      name: name,
      option: option,
      buttonStyle: option.buttonStyle || buttonStyle,
      row: row,
      checked: option.value === value,
      onChange: onChange,
      disabled: option.disabled
    }));
  }
  return /*#__PURE__*/_react.default.createElement(StyledFieldset, {
    className: className
  }, legend && /*#__PURE__*/_react.default.createElement("legend", null, legend), /*#__PURE__*/_react.default.createElement(StyleRadioContainer, {
    "aria-describedby": ariaDescribedby,
    role: "radiogroup",
    row: row
  }, radios));
};
exports.RadioButtonGroup = RadioButtonGroup;
RadioButtonGroup.propTypes = {
  className: _propTypes.default.string,
  /**
   * ID for an HTML node that can be used to announce the radio group
   */
  ariaDescribedby: _propTypes.default.string,
  /**
   * The name property to apply to the form group
   */
  name: _propTypes.default.string,
  /**
   * Whether to display the buttons in a row (when false buttons are displayed in a single column)
   */
  row: _propTypes.default.bool,
  /**
   * Which value is currently selected (required - this component cannot manage it's own state)
   */
  value: _propTypes.default.string,
  /**
   * Callback for handling changes to the selected radio button
   * args: (event, optionString)
   */
  onChange: _propTypes.default.func.isRequired,
  /**
   * A list of options to create radio buttons for.
   * Example: [{value: 'f', label: 'Female'}, ...]
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    buttonStyle: _propTypes.default.oneOf(['primary', 'secondary']),
    ariaDescribedby: _propTypes.default.string,
    /** An element containing a descriptive text for screen readers */
    description: _propTypes.default.node,
    disabled: _propTypes.default.bool
  })).isRequired,
  'aria-describedby': _propTypes.default.string,
  'aria-invalid': _propTypes.default.bool,
  /**
   * Styles to apply when operating in buttons mode
   */
  buttonStyle: _propTypes.default.oneOf(['primary', 'secondary']),
  /**
   * The legend to render above the radios
   */
  legend: _propTypes.default.string,
  /**
   * A renderer for the body of the label that displays to the user when it is not selected
   */
  RenderOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * A renderer for the body of the label that displays to the user when it is selected
   */
  RenderSelectedOption: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Text color for when the component is focused ~but unchecked~
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusTextColor: _propTypes.default.string,
  /**
   * Background color for when the component is focused ~but unchecked~
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusBackgroundColor: _propTypes.default.string,
  /**
   * Outline color for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineColor: _propTypes.default.string,
  /**
   * Outline width for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineWidth: _propTypes.default.string,
  /**
   * Outline style for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineStyle: _propTypes.default.string,
  /**
   * Outline offset for when the component is focused and checked or unchecked
   * Applies when component is rendering <CustomRadioButton /> for its inputs
   */
  focusOutlineOffset: _propTypes.default.string
};
RadioButtonGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RadioButtonGroup",
  "props": {
    "className": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "ariaDescribedby": {
      "description": "ID for an HTML node that can be used to announce the radio group",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "name": {
      "description": "The name property to apply to the form group",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "row": {
      "description": "Whether to display the buttons in a row (when false buttons are displayed in a single column)",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "value": {
      "description": "Which value is currently selected (required - this component cannot manage it's own state)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "description": "Callback for handling changes to the selected radio button\nargs: (event, optionString)",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "options": {
      "description": "A list of options to create radio buttons for.\nExample: [{value: 'f', label: 'Female'}, ...]",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "value": {
              "name": "string",
              "required": true
            },
            "label": {
              "name": "string",
              "required": true
            },
            "buttonStyle": {
              "name": "enum",
              "value": [{
                "value": "'primary'",
                "computed": false
              }, {
                "value": "'secondary'",
                "computed": false
              }],
              "required": false
            },
            "ariaDescribedby": {
              "name": "string",
              "required": false
            },
            "description": {
              "name": "node",
              "description": "An element containing a descriptive text for screen readers",
              "required": false
            },
            "disabled": {
              "name": "bool",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "aria-describedby": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "aria-invalid": {
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "buttonStyle": {
      "description": "Styles to apply when operating in buttons mode",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false
    },
    "legend": {
      "description": "The legend to render above the radios",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "RenderOption": {
      "description": "A renderer for the body of the label that displays to the user when it is not selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "RenderSelectedOption": {
      "description": "A renderer for the body of the label that displays to the user when it is selected",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false
    },
    "focusTextColor": {
      "description": "Text color for when the component is focused ~but unchecked~\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusBackgroundColor": {
      "description": "Background color for when the component is focused ~but unchecked~\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineColor": {
      "description": "Outline color for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineWidth": {
      "description": "Outline width for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineStyle": {
      "description": "Outline style for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "focusOutlineOffset": {
      "description": "Outline offset for when the component is focused and checked or unchecked\nApplies when component is rendering <CustomRadioButton /> for its inputs",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};